module.exports = __webpack_public_path__ + "static/media/SearchStart.c2240902.png";